import { useCallback, useMemo, useState } from "react";
import { useApolloClient } from "@apollo/client";

import { useAppDispatch, useAppSelector } from "../../../Store";

import { PanelBasicQueryInfoInput, FeedComponentsResponse, GET_FEED_COMPONENTS_INFO } from "./GQLCalls/getFeedComponentsCall";
import { MAINTAIN_FEED_COMPONENTS_INFO, PanelMaintainFeedComponentsResponse } from "./GQLCalls/updateFeedComponents";
import { gqlActions } from "../gqlData_Reducer";
import { FeedComponentItem } from "./FeedDataSlices/feedComponentsSlice";
import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { noop } from "lodash";
import { filterByConnection } from "../filterByConnection";

export const useFeedComponents = (connection: Graph_QL.GQLCons): GqlHook_Returns<FeedComponentItem, PanelBasicQueryInfoInput> => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [, setCursorId] = useState(-1);

  const feedComponentsState = useAppSelector(({graphQlData:{domain}}) => domain.feedComponents);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(feedComponentsState, Graph_QL.ToArr(connection)) as Record<string, FeedComponentItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<FeedComponentItem>)
  },[connection, feedComponentsState]);

  const getFeedComponentsInfo = useCallback(async (input: PanelBasicQueryInfoInput, specific?: Graph_QL.GQLCons) => {
    try {
    client.query<FeedComponentsResponse>({query: GET_FEED_COMPONENTS_INFO, variables: {...specific?.connection, input}})
      .then((e) => {
        if (e && e.data) {
          dispatch({type: String(gqlActions.domain.feedComponents.add), payload: {con: connection?.connection, data: e.data.feedComponent.info}});
          setCursorId(e.data.feedComponent.info.at(-1)?.id ?? -1)
        }
      }).catch((error) => {console.log(error); })}
    catch {
      console.log("gok");
         // TODO CTO This is only for when graphql fails currently the test data should never be populated in production
      }
    },[client, connection?.connection, dispatch])
  
  const fetchMore = async (cursor: number|number[], specific?: Graph_QL.GQLCons) => {
    // TODO This used to work but changes to the query broke it.
    }

  const maintainEntries = useCallback(async (changedData?: Partial<FeedComponentItem>) => {
    
    const typeGuardedChangedData = {
      con: changedData?.con,
      data: changedData?.data?.map((info) => {
        return {
          ...info,
          priority: +info.priority,
          ds: +info.ds,
          energy: +info.energy,
          protein: +info.protein
        }
      })
    }
    try {
      client.mutate<PanelMaintainFeedComponentsResponse>({mutation: MAINTAIN_FEED_COMPONENTS_INFO, variables: {...connection.connection, maintainFeedComponents: typeGuardedChangedData?.data}})
      .then((e) => {
        if (e && e.data) {
         dispatch({type: String(gqlActions.domain.feedComponents.maintained), payload: {con: connection?.connection, data: e.data.feedComponent.maintain.updatedValues}});
        }
      }).catch((error) => {console.log(error)})
    } catch {
      console.warn("The update failed -> no changes dispatched")
    }
  },[client, connection.connection, dispatch])

  return {call: getFeedComponentsInfo, fetchMore, deleteEntries: noop, data: fullState, maintainEntries}
} 

